export default [
    //FOR BRANCH USER========================================================================
    {
        subject: "pr",
        key: "newPr", //this is the parameter found in the url /form/:key 
        pageTitle: "New Purchase Request",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        updateMainInfoWhenLoaded:{ // this use to update the main info settings when user updated the PR item(add,update,delete)
                                   //we need to get the fresh data so that the total and subtotal is shown
            route:"purchaseRequests"
                   
        },
        tableSettings: {
            route: "purchaseRequests",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "New PR",
                userId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getPRbyUserIdAndStatus",
            showAddBtn: true,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: { 
                prStatus: "New PR",
                userId: "" // we set this on the fly
            }

        },
    },
    {
        subject: "pr",
        key: "userApprovedPR", //this is the parameter found in the url /form/:key 
        pageTitle: "Approved By HOD Purchase Request",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "purchaseRequests", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Submitted PR Team",
                userId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getPRbyUserIdAndStatus",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,
        },
    },
    {
        subject: "pr",
        key: "userApprovedByProcurement", //this is the parameter found in the url /form/:key 
        pageTitle: "Approved By Procurement Team",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "purchaseRequests", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "PO Generated",
                userId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getPRbyUserIdAndStatus",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,
        },
    },
    {
        subject: "pr",
        key: "Submitted HOD", //this is the parameter found in the url /form/:key 
        pageTitle: "Pending Purchase Request",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "purchaseRequests", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Submitted HOD",
                userId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getPRbyUserIdAndStatus",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,

        },
    },
    {
        subject: "pr",
        key: "Rejected PR", //this is the parameter found in the url /form/:key 
        pageTitle: "Rejected By HOD Purchase Request",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "purchaseRequests", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Rejected PR",
                userId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getPRbyUserIdAndStatus",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,

        },
    },

    //----------------------------------------------------------------------------------------------
    //FOR HOD========================================================================================

    {
        subject: "pr",
        key: "HOD Pending Approval", //this is the parameter found in the url /form/:key 
        pageTitle: "Pending for Approval by HOD",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "purchaseRequests", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Submitted HOD",
                branchId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getPRByBranchAndStatus",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,

        },
    },
    {
        subject: "pr",
        key: "submittedToPr", //this is the parameter found in the url /form/:key 
        pageTitle: "Approved PR and Submited To Procurement",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "purchaseRequests", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Submitted PR Team",
                branchId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getPRByBranchAndStatus",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,

        },
    },
    {
        subject: "pr",
        key: "hodRejectedByhod", //this is the parameter found in the url /form/:key 
        pageTitle: "Rejected By Me",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "purchaseRequests", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Rejected by HOD",
                branchId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getPRByBranchAndStatus",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,

        },
    },
    {
        subject: "pr",
        key: "hodRejectedByPR", //this is the parameter found in the url /form/:key 
        pageTitle: "Rejected By Procurement",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "purchaseRequests", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Rejected by Procurement",
                branchId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
            },
            filterEndpoint: "getPRByBranchAndStatus",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,

        },
    },
    //----------------------------------------------------------------------------------------------
    //FOR PROCUREMENT TEAM==========================================================================
    {
        subject: "pr",
        key: "pendingApprovalByPR", //this is the parameter found in the url /form/:key 
        pageTitle: "Pending for Approval by PR Team",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "purchaseRequests", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Submitted PR Team",
            },
            filterEndpoint: "getByStatus",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,

        },
    },
    {
        subject: "pr",
        key: "PO Generated", //this is the parameter found in the url /form/:key 
        pageTitle: "PO Generated",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "purchaseRequests", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "PO Generated",
            },
            filterEndpoint: "getByStatus",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,

        },
    },
    {
        subject: "pr",
        key: "Rejected by Procurement", //this is the parameter found in the url /form/:key 
        pageTitle: "Rejected By Procurement Team",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "purchaseRequests", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Rejected by Procurement",
            },
            filterEndpoint: "getByStatus",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,

        },
    },
    {
        subject: "report",
        key: "userPR", //this is the parameter found in the url /form/:key 
        pageTitle: "Your PR",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "purchaseRequests", //the main route for CRUD
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                userId: "",
            },
            filterEndpoint: "getPRbyUserId",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },
    
]